import * as _ from 'lodash'
import {IConsumptionAdjustmentCollectionContext} from "./PA.UIM.Consumption.IF";
import {WB_ConsumptionProductGroupRow, WB_CustomerRow, WB_ProductGroupRow} from "../PA.Core/PAdbSchemaRows";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {IDateRange, IProgressProvider} from "../PA.Core/PA.Core.IF.Basic";
import {IHaveExecutionBounds} from "../PA.Core/PA.Core.IF.Aspects";
import {IConsumptionAdjustmentsFactory} from "../PA.Consumption.Core/PA.Consumption.IF";
import {Subscription} from "rxjs/Subscription";
import {ProgressProvider} from "../PA.Core/Basic/Progress";
import {DateUtils} from "../PA.Core/Basic/Dates";
import {ConsumptionAdjustmentsFactory} from "../PA.Consumption.Core/ConsumptionAdjustmentsFactory";

const bDebug = true

export interface IConsAdjCollectionCtxOptions {
  loadRequirement_iSourceCustomers?: number,
  loadRequirement_iPromotedGroups?: number,
  loadRequirement_allRecordThreshold?: number
}

const ConsAdjCollectionCtxOptions_default: IConsAdjCollectionCtxOptions = {
  loadRequirement_iSourceCustomers: 1,
  loadRequirement_iPromotedGroups: 1,
  loadRequirement_allRecordThreshold: 1000
}


export class ConsumptionAdjustmentCollectionContext
  implements IConsumptionAdjustmentCollectionContext
{
  private createOptions: IConsAdjCollectionCtxOptions
  private factory: IConsumptionAdjustmentsFactory
  private executionBounds: IHaveExecutionBounds
  private subExecutionBoundsChanged: Subscription = undefined

  private loadProgressProvider: ProgressProvider = new ProgressProvider("Loading Adj")
  private bLoading: boolean
  private bResetLoadedCache: boolean


  private _allConsumptionAdjustments: WB_ConsumptionProductGroupRow[]
  private _consumptionAdjustmentsChanged: BehaviorSubject<IConsumptionAdjustmentCollectionContext>
  private _dctLoaded: {[wbPlnCstId: number]: {[wbSrcCstId: number]: {[wbPrdGrpId: number]: {arr: WB_ConsumptionProductGroupRow[], dctStartDt: {[sStartDt:string]: number}} }}}

  private _filteredConsumptionAdjustments: WB_ConsumptionProductGroupRow[];
  private _filteredConsumptionAdjustmentsChanged: BehaviorSubject<IConsumptionAdjustmentCollectionContext>;



  private _planningCustomers_All: WB_CustomerRow[];
  private _planningCustomers_Selected: WB_CustomerRow[];
  private _planningCustomers_Loaded: {[id:number]: WB_CustomerRow };

  private _sourceCustomers_All: WB_CustomerRow[];
  private _sourceCustomers_Selected: WB_CustomerRow[];
  private _sourceCustomers_Loaded: {[id:number]: WB_CustomerRow };

  private _productGroups_All: WB_ProductGroupRow[];
  private _productGroups_Selected: WB_ProductGroupRow[];
  private _productGroups_Loaded: {[id:number]: WB_ProductGroupRow };

  private _dateRange_Bounds: IDateRange;
  private _dateRange_Selected: IDateRange;
  private _dateRange_Loaded: IDateRange;

  //private _boundsChanged: BehaviorSubject<IConsumptionAdjustmentCollectionContext>
  private _selectedChanged: BehaviorSubject<IConsumptionAdjustmentCollectionContext>;



  constructor(options?: IConsAdjCollectionCtxOptions) {
    this.createOptions = options || {}
    _.defaults(this.createOptions, ConsAdjCollectionCtxOptions_default)

    this.factory = new ConsumptionAdjustmentsFactory()
    this.executionBounds = undefined

    this._allConsumptionAdjustments = []
    this._dctLoaded = {}
    this._consumptionAdjustmentsChanged = new BehaviorSubject<IConsumptionAdjustmentCollectionContext>(this)

    this._planningCustomers_All = []
    this._planningCustomers_Selected = []
    this._planningCustomers_Loaded = {}

    this._sourceCustomers_All = []
    this._sourceCustomers_Selected = []
    this._sourceCustomers_Loaded = {}

    this._productGroups_All = []
    this._productGroups_Selected = []
    this._productGroups_Loaded = {}

    this._dateRange_Bounds = {StartDt: undefined, EndDt: undefined }
    this._dateRange_Selected = {StartDt: undefined, EndDt: undefined }
    this._dateRange_Loaded = {StartDt: undefined, EndDt: undefined }

    //this._boundsChanged = new BehaviorSubject<IConsumptionAdjustmentCollectionContext>(this)
    this._selectedChanged = new BehaviorSubject<IConsumptionAdjustmentCollectionContext>(this)

    this._filteredConsumptionAdjustments = []
    this._filteredConsumptionAdjustmentsChanged = new BehaviorSubject<IConsumptionAdjustmentCollectionContext>(this)

    this.bLoading = false
    this.bResetLoadedCache = false

  }

  Register(anExecutionBounds: IHaveExecutionBounds): void {

    const self = this

    self.UnRegister()

    self.executionBounds = anExecutionBounds

    self.executionBounds.OnIHaveExecutionBoundsLoaded
      .then((eb: IHaveExecutionBounds) => {
        self.subExecutionBoundsChanged = eb.ExecutionBoundsChanged.subscribe(self.evtExecutionBoundsChanged.bind(self))
        self.SelectedChanged.next(self)
      }).catch((err) => {
          console.error(`OnIHaveExecutionBoundsLoaded error: ${err}`)
      })

  }

  UnRegister(): void {

    if(this.subExecutionBoundsChanged){
      this.subExecutionBoundsChanged.unsubscribe()
    }
  }

  private evtExecutionBoundsChanged(execb: IHaveExecutionBounds): void {
    const self = this

    if(_.isEmpty(self.executionBounds))
      return;

    (async () => {
      if(!self.executionBounds.bIHaveExecutionBoundsLoaded)
        await self.executionBounds.OnIHaveExecutionBoundsLoaded

      if(self.executionBounds.bIHaveExecutionBoundsLoaded) {
        self.SetOutsideBounds(self.executionBounds.Execution_PlanningCustomers,
            self.executionBounds.Execution_SourceCustomers,
            self.executionBounds.Execution_ProductGroups,
            self.executionBounds.Execution_InStore_Aligned.StartDt,
            self.executionBounds.Execution_InStore_Aligned.EndDt)
      }
    })();
  }


  private SetOutsideBounds(arrWB_Cust_Planning: WB_CustomerRow[],
                           arrWB_Cust_Source: WB_CustomerRow[],
                           arrWB_PrdGrp: WB_ProductGroupRow[],
                           StartDt: Date,
                           EndDt: Date): void
  {
    const self = this

    // Set outside Bounds
    self._planningCustomers_All = arrWB_Cust_Planning
    self._planningCustomers_Selected = arrWB_Cust_Planning  // Force this, as it's not shown on the UI..
    self._sourceCustomers_All = arrWB_Cust_Source
    self._productGroups_All = arrWB_PrdGrp
    self._dateRange_Bounds = {StartDt: StartDt, EndDt: EndDt }

    let dctPlnCst = _.keyBy(self._planningCustomers_All, (a) => a.cif.WB_CUST_ID)
    let dctSrcCst = _.keyBy(self._sourceCustomers_All, (a) => a.cif.WB_CUST_ID)
    let dctPrdGrps = _.keyBy(self._productGroups_All, (a) => a.cif.WB_PRDGRP_ID)

    // Determine if Selection has Changed...
    //--
    let bSelectionChanged = false

    let removedPC = _.remove(self._planningCustomers_Selected, (a) => !(a.cif.WB_CUST_ID in dctPlnCst))
    let removedSC = _.remove(self._sourceCustomers_Selected, (a) => !(a.cif.WB_CUST_ID in dctSrcCst))
    let removedPG = _.remove(self._productGroups_Selected, (a) => !(a.cif.WB_PRDGRP_ID in dctPrdGrps))

    bSelectionChanged = (removedPC.length + removedSC.length + removedPG.length) > 0
    if(!DateUtils.isEqual(self._dateRange_Bounds?.StartDt, self._dateRange_Selected?.StartDt)){
      bSelectionChanged = true
    }
    if(!DateUtils.isEqual(self._dateRange_Bounds?.EndDt, self._dateRange_Selected?.EndDt)){
      bSelectionChanged = true
    }

    // Check if we need to reset the loaded Keys
    if(DateUtils.isLessThan(self._dateRange_Bounds.StartDt, self._dateRange_Loaded.StartDt)){
      self.bResetLoadedCache = true;
    }

    if(DateUtils.isGreaterThan(self._dateRange_Bounds.EndDt, self._dateRange_Loaded.EndDt)){
      self.bResetLoadedCache = true;
    }

    self._dateRange_Selected = {StartDt: StartDt, EndDt: EndDt }

    //self._boundsChanged.next(self)
    if(bSelectionChanged)
      self._selectedChanged.next(self)

    self.RunLoading()

  }

    // Load Consumption Records

  async RunLoading(bSelectedChanged?: boolean): Promise<void>
  {
    const self = this

    if(this.bLoading){
      console.log("Already loading..")
      return
    }


    self.bLoading = true
    if(bDebug)
      console.log("Starting RunLoading processing")

    if(self.bResetLoadedCache){
      self.bResetLoadedCache = false
      self._planningCustomers_Loaded = {}
      self._sourceCustomers_Loaded = {}
      self._productGroups_Loaded = {}
      self._allConsumptionAdjustments = []
    }

    self.LoadProgressProvider.start("Loading")
    self.LoadProgressProvider.setPercentComplete(0.20)

    function doneLoading(sMsg?: string){
      self.bLoading  = false
      self.LoadProgressProvider.finish()
      if(bDebug)
        console.log("Done RunLoading processing: ", sMsg)
      self.updateFilteredDataset()
    }

    //-- Determine what to Load,
    if((self.PlanningCustomers_Selected.length == 0) ||
       (self.SourceCustomers_Selected.length == 0) ||
       (self.ProductGroups_Selected.length == 0))
    {
      doneLoading("Nothing Selected")
      return
    }

    // How to determine the Delta Load..
    //-- Dimensions that have missing items, require the other dimensions to be fully loaded.
    //--
    let planningCustomers_notLoaded: WB_CustomerRow[] = []
    let sourceCustomers_notLoaded: WB_CustomerRow[] = []
    let productGroups_notLoaded: WB_ProductGroupRow[] = []

    _.forEach(self.PlanningCustomers_Selected, (aPC) => {
      if(!(aPC.cif.WB_CUST_ID in self._planningCustomers_Loaded)){
        planningCustomers_notLoaded.push(aPC)
      }
    })

    _.forEach(self.SourceCustomers_Selected, (aSC) => {
      if(!(aSC.cif.WB_CUST_ID in self._sourceCustomers_Loaded)){
        sourceCustomers_notLoaded.push(aSC)
      }
    })

    _.forEach(self.ProductGroups_Selected, (aPG) => {
      if(!(aPG.cif.WB_PRDGRP_ID in self._productGroups_Loaded)){
        productGroups_notLoaded.push(aPG)
      }
    })

    // Check if nothing needs to be loaded
    if((planningCustomers_notLoaded.length == 0) &&
       (sourceCustomers_notLoaded.length == 0) &&
       (productGroups_notLoaded.length == 0)){
      doneLoading("Nothing needs to be loaded")
      return
    }

    //-- Load in one pass or two..
    //--  All Selected Planning Customers are included.

    //-- Load in one pass when
    //--  One of the dimensions has nothing loaded.

    //-- Load two passes otherwise, since it's more efficient
    //-

    // One Pass Load
    if(_.isEmpty(self._sourceCustomers_Loaded) || _.isEmpty(self._productGroups_Loaded)){
      let arrCnsPGs1
        = await self.factory.Load(_.map(self._planningCustomers_Selected, (pc) => { return pc.cif.WB_CUST_ID} ),
                                  _.map(self._sourceCustomers_Selected, (sc) => { return sc.cif.WB_CUST_ID}),
                                  _.map(self._productGroups_Selected, (pg) => { return pg.cif.WB_PRDGRP_ID}),
                                  self._dateRange_Bounds.StartDt,
                                  self._dateRange_Bounds.EndDt)

      self.mergeLoadedRecords(arrCnsPGs1)
    } else {
      // Two Pass, one for Source Customer, one for PG
      if(sourceCustomers_notLoaded.length){
        let arrCnsPGs2
          = await self.factory.Load(_.map(self._planningCustomers_Selected, (pc) => { return pc.cif.WB_CUST_ID} ),
                                    _.map(sourceCustomers_notLoaded, (sc) => { return sc.cif.WB_CUST_ID}),
                                    _.map(self._productGroups_Selected, (pg) => { return pg.cif.WB_PRDGRP_ID}),
                                    self._dateRange_Bounds.StartDt,
                                    self._dateRange_Bounds.EndDt)

        self.mergeLoadedRecords(arrCnsPGs2)
      }

      if(productGroups_notLoaded.length){
        let arrCnsPGs3
          = await self.factory.Load(_.map(self._planningCustomers_Selected, (pc) => { return pc.cif.WB_CUST_ID} ),
                                    _.map(self._sourceCustomers_Selected, (sc) => { return sc.cif.WB_CUST_ID}),
                                    _.map(productGroups_notLoaded, (pg) => { return pg.cif.WB_PRDGRP_ID}),
                                    self._dateRange_Bounds.StartDt,
                                    self._dateRange_Bounds.EndDt)

        self.mergeLoadedRecords(arrCnsPGs3)
      }

    }

    //-- Updated Loaded Dictionaries
    _.forEach(planningCustomers_notLoaded, (aPC) => {
      self._planningCustomers_Loaded[aPC.cif.WB_CUST_ID] = aPC
    })

    _.forEach(sourceCustomers_notLoaded, (aSC) => {
      self._sourceCustomers_Loaded[aSC.cif.WB_CUST_ID] = aSC
    })

    _.forEach(productGroups_notLoaded, (aPG) => {
      self._productGroups_Loaded[aPG.cif.WB_PRDGRP_ID] = aPG
    })

    self.LoadProgressProvider.setPercentComplete(0.80)
    doneLoading("Completed Loading Passes")

    setTimeout(() => {
      self.RunLoading()
    }, 0)

  }

  private mergeLoadedRecords(arrWBCnsPG: WB_ConsumptionProductGroupRow[]) {
    const self = this

    _.forEach(arrWBCnsPG, (aCnsPG) => {
      if(!(aCnsPG.cif.WB_CUST_ID_PLANNING in self._dctLoaded)){
        self._dctLoaded[aCnsPG.cif.WB_CUST_ID_PLANNING] = {}
      }
      let dctSC = self._dctLoaded[aCnsPG.cif.WB_CUST_ID_PLANNING]

      if(!(aCnsPG.cif.WB_CUST_ID_SOURCE in dctSC)){
        dctSC[aCnsPG.cif.WB_CUST_ID_SOURCE] = {}
      }
      let dctPG = dctSC[aCnsPG.cif.WB_CUST_ID_SOURCE]

      if(!(aCnsPG.cif.WB_PRDGRP_ID in dctPG)){
        dctPG[aCnsPG.cif.WB_PRDGRP_ID] = {arr: [], dctStartDt: {}}
      }

      let pgEntry = dctPG[aCnsPG.cif.WB_PRDGRP_ID]
      if(!(aCnsPG.cif.START_DT in pgEntry.dctStartDt)){
        pgEntry.dctStartDt[aCnsPG.cif.START_DT] = aCnsPG.cif.WB_CNSPG_ID
        pgEntry.arr.push(aCnsPG)
        self._allConsumptionAdjustments.push(aCnsPG)
      }

    })
  }


  private updateFilteredDataset(){
     let self = this

     let resultSet: WB_ConsumptionProductGroupRow[] = []

    _.forEach(self._planningCustomers_Selected, (aPC) => {
      if(!(aPC.cif.WB_CUST_ID in self._dctLoaded)){ return }
      let dctSC = self._dctLoaded[aPC.cif.WB_CUST_ID]
      _.forEach(self._sourceCustomers_Selected, (aSC) => {
        if(!(aSC.cif.WB_CUST_ID in dctSC)){ return }
        let dctPG = dctSC[aSC.cif.WB_CUST_ID]
        _.forEach(self._productGroups_Selected, (aPG) => {
          if(!(aPG.cif.WB_PRDGRP_ID in dctPG)){ return }
          let PGentry = dctPG[aPG.cif.WB_PRDGRP_ID];

          // Filter by Date
          _.forEach(PGentry.arr, (cnsPG) => {
            if (DateUtils.InRange(cnsPG.DateRange.Range.EndDt, self._dateRange_Selected)) {
              resultSet.push(cnsPG)
            }
          })
        })
      })
    })

    self._filteredConsumptionAdjustments = resultSet
    self._filteredConsumptionAdjustmentsChanged.next(self)

  }



  Save(arrWB_Cust_ID_Planning: number[], arrWB_PrdGrp_ID: number[]): Promise<void> {
    return this.factory.Save(arrWB_Cust_ID_Planning, arrWB_PrdGrp_ID)
  }

  get AllConsumptionAdjustments(): WB_ConsumptionProductGroupRow[] {
    return this._allConsumptionAdjustments
  }

  get ConsumptionAdjustmentsChanged(): BehaviorSubject<IConsumptionAdjustmentCollectionContext> {
    return this._consumptionAdjustmentsChanged
  }

  get LoadProgressProvider(): IProgressProvider {
    return this.loadProgressProvider
  }

  get PlanningCustomers_All(): WB_CustomerRow[] {
    return this._planningCustomers_All
  }

  get PlanningCustomers_Selected(): WB_CustomerRow[] {
    return this._planningCustomers_Selected
  }

  set PlanningCustomers_Selected(value) {
    this._planningCustomers_Selected = value
    this._selectedChanged.next(this)
    this.RunLoading()
  }


  get SourceCustomers_All(): WB_CustomerRow[] {
    return this._sourceCustomers_All
  }

  get SourceCustomers_Selected(): WB_CustomerRow[] {
    return this._sourceCustomers_Selected
  }

  set SourceCustomers_Selected(value) {
    this._sourceCustomers_Selected = value
    this._selectedChanged.next(this)
    this.RunLoading()
  }

  get ProductGroups_All(): WB_ProductGroupRow[] {
    return this._productGroups_All
  }

  get ProductGroups_Selected(): WB_ProductGroupRow[] {
    return this._productGroups_Selected
  }

  set ProductGroups_Selected(value) {
    this._productGroups_Selected = value
    this._selectedChanged.next(this)
    this.RunLoading()
  }

  get DateRange_Bounds(): IDateRange {
    return this._dateRange_Bounds
  }

  get DateRange_Selected(): IDateRange {
    return this._dateRange_Selected
  }

  set DateRange_Selected(value) {
    this._dateRange_Selected = value
    this._selectedChanged.next(this)
    this.RunLoading()
  }

  //get BoundsChanged(): BehaviorSubject<IConsumptionAdjustmentCollectionContext> {  return this._boundsChanged }

  get SelectedChanged(): BehaviorSubject<IConsumptionAdjustmentCollectionContext> { return this._selectedChanged }

  get FilteredConsumptionAdjustments(): WB_ConsumptionProductGroupRow[] { return this._filteredConsumptionAdjustments }

  get FilteredConsumptionAdjustmentsChanged(): BehaviorSubject<IConsumptionAdjustmentCollectionContext> {  return this._filteredConsumptionAdjustmentsChanged }

}


